import { render, staticRenderFns } from "./guardian-group-config.vue?vue&type=template&id=181b9683"
import script from "./guardian-group-config.ts?vue&type=script&lang=js&external"
export * from "./guardian-group-config.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports